import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from '@app/../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ProductStoredAreasService {
  public endpoint: string = environment.apiUrl + '/product-stored-area';

  constructor(
    private http: HttpClient,
    ) { }

  public onSortAreas(products, area): Observable<any>{
    return this.http.patch(`${this.endpoint}/sort`,{
      products,
      area: area
    });
  }

  
}
